import { Button, Classes, Dialog, Intent } from '@blueprintjs/core'
import React from 'react'
import { AxiosPromise } from 'axios'
import APIErrorCallout from '../../../components/errors/APIErrorCallout'
import { showToast } from '../../../Toast'
import { S, readQueryParams } from '../../../utils'
import { trackNeedsAttentionListingEvent } from '../../home/v2/utils'
import { pluralize } from '../../../utils/string'

interface Props {
  onClose: (changePerformed?: boolean, failedIds?: any[]) => void
  data: any
  listEndpoint: (ids, shopifyListingForm?) => AxiosPromise
  isOpen: boolean
  marketName: string
  message?: string
  onSubmitted?: Function
}

export default class ListDialog extends React.Component<Props> {
  state = {
    loading: false,
    error: null
  }

  list = async () => {
    const { data, listEndpoint, onSubmitted } = this.props
    this.setState({ loading: true, error: null })

    try {
      const res = await listEndpoint(data)
      if (onSubmitted) onSubmitted()
      if (readQueryParams().tab === 'attention-required') trackNeedsAttentionListingEvent('list', data.length)
      this.setState({ loading: false }, () => {
        showToast(`Listing ${data.length} item${S(data)}...`, Intent.PRIMARY)
        this.props.onClose(true, res.data.failed)
      })
    } catch (error) {
      this.setState({
        loading: false,
        error: error.response
      })
    }
  }

  onClose = () => {
    this.setState(
      {
        loading: false,
        error: null
      },
      this.props.onClose
    )
  }

  render() {
    const { isOpen, data, marketName, message } = this.props
    const { loading, error } = this.state

    return (
      <Dialog isOpen={isOpen} onClose={this.onClose} title="List">
        {error && <APIErrorCallout response={error} />}
        <div className={Classes.DIALOG_BODY}>
          {message || `This will immediately list the selected listing${pluralize(data)} to ${marketName}.`}
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button loading={loading} intent={Intent.PRIMARY} onClick={this.list}>
              List {data.length} item{S(data)}
            </Button>
          </div>
        </div>
      </Dialog>
    )
  }
}
